/* dede — genel davranışlar */
(function () {
var D = document, R = D.documentElement;
function each(sel, fn, root) { Array.prototype.forEach.call((root || D).querySelectorAll(sel), fn); }

/* header menüsü ve yapışkan başlık: sections/header.liquid içinde */

/* ---------- sekmeler (tema editöründe bölüm yenilenince yeniden bağlanır) ---------- */
function initTabs(root) {
  if (root._dedeTabs) return;
  root._dedeTabs = true;
  var tabs = root.querySelectorAll('.pp-tabs__tab'), panels = root.querySelectorAll('.pp-tabs__panel');
  function activate(id) {
    tabs.forEach(function (t) { var on = t.dataset.tab === id; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
    panels.forEach(function (p) { p.hidden = p.dataset.panel !== id; });
    root.dispatchEvent(new CustomEvent('dede:tabchange', { bubbles: true }));
  }
  root._activate = activate;
  tabs.forEach(function (t, k) {
    t.addEventListener('click', function () { activate(t.dataset.tab); });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        var n = (k + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[n].focus(); activate(tabs[n].dataset.tab);
      }
    });
  });
}
each('[data-tabs]', initTabs);
D.addEventListener('shopify:section:load', function (e) { each('[data-tabs]', initTabs, e.target); });
D.addEventListener('shopify:block:select', function (e) {
  var t = e.target && e.target.closest ? e.target.closest('.pp-tabs__tab') : null;
  var root = t && t.closest('[data-tabs]');
  if (root && root._activate) root._activate(t.dataset.tab);
});

/* ---------- önerilen ürün kaydırıcısı ---------- */
each('[data-carousel]', function (c) {
  var track = c.querySelector('[data-track]'), dotsWrap = c.querySelector('[data-dots]');
  if (!track || !dotsWrap) return;
  var dots = [], pages = 0, step = 1;
  function metrics() {
    var cards = track.children.length, first = track.firstElementChild;
    if (!track.clientWidth || !first) return null;
    var cw = first.getBoundingClientRect().width;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    var perView = Math.max(1, Math.floor((track.clientWidth + gap + 1) / (cw + gap)));
    step = perView * (cw + gap);
    return { pages: Math.max(1, Math.ceil(cards / perView)) };
  }
  function build() {
    var m = metrics(); if (!m) return;
    if (m.pages === pages) { paint(); return; }
    pages = m.pages; dotsWrap.innerHTML = ''; dots = [];
    if (pages < 2) return;
    var inner = D.createElement('div'); inner.className = 'rp__dots-inner';
    for (var i = 0; i < pages; i++) {
      var b = D.createElement('button'); b.type = 'button'; b.className = 'rp__dot'; b.setAttribute('aria-label', 'Sayfa ' + (i + 1));
      (function (k) { b.addEventListener('click', function () { track.scrollTo({ left: k * step, behavior: 'smooth' }); }); })(i);
      inner.appendChild(b); dots.push(b);
    }
    dotsWrap.appendChild(inner); paint();
  }
  function paint() {
    if (!dots.length) return;
    var i = Math.min(dots.length - 1, Math.round(track.scrollLeft / step));
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
  }
  var raf = null;
  track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; paint(); }); }, { passive: true });
  addEventListener('resize', function () { pages = 0; build(); });
  D.addEventListener('dede:tabchange', build);
  D.addEventListener('shopify:section:load', build);
  build();
});

/* ---------- banner slider (ekran dışındayken durur, dikey kaydırmayı slayt geçişi sanmaz) ---------- */
each('[data-hero]', function (hero) {
  var slides = hero.querySelectorAll('.hero__slide'),
      dots = hero.querySelectorAll('.hero__dot'),
      delay = parseInt(hero.dataset.autoplay, 10) || 0,
      reduce = matchMedia('(prefers-reduced-motion: reduce)').matches,
      i = 0, timer = null, seen = true;
  if (slides.length < 2) return;

  function go(n) {
    i = (n + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
  }
  function start() { stop(); if (delay && !reduce && seen && !D.hidden) timer = setInterval(function () { go(i + 1); }, delay); }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }

  dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.heroGoto); start(); }); });
  var prev = hero.querySelector('[data-hero-prev]'), next = hero.querySelector('[data-hero-next]');
  if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
  if (next) next.addEventListener('click', function () { go(i + 1); start(); });

  hero.addEventListener('mouseenter', stop);
  hero.addEventListener('mouseleave', start);
  hero.addEventListener('focusin', stop);
  hero.addEventListener('focusout', start);
  D.addEventListener('visibilitychange', start);
  if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { seen = en[0].isIntersecting; start(); }).observe(hero);

  var x0 = null, y0 = 0;
  hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; stop(); }, { passive: true });
  hero.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) go(dx < 0 ? i + 1 : i - 1);
    start();
  }, { passive: true });

  D.addEventListener('shopify:block:select', function (e) {
    var sl = e.target && e.target.closest ? e.target.closest('.hero__slide') : null;
    if (sl && hero.contains(sl)) { delay = 0; stop(); go(+sl.dataset.slide); }
  });
  D.addEventListener('shopify:block:deselect', function () { delay = parseInt(hero.dataset.autoplay, 10) || 0; start(); });

  start();
});

/* ---------- header sepet sayısı ---------- */
(function () {
  function paint(count) {
    each('[data-cart-count]', function (el) { el.firstChild.nodeValue = String(count); el.hidden = !count; });
  }
  D.addEventListener('dede:cart:updated', function (e) {
    if (e.detail && typeof e.detail.item_count === 'number') paint(e.detail.item_count);
  });
  addEventListener('pageshow', function (e) {
    if (e.persisted && !D.querySelector('[data-cart-drawer]')) D.dispatchEvent(new CustomEvent('dede:cart:added'));
  });
  D.addEventListener('dede:cart:added', function () {
    /* çekmece varsa sayıyı o günceller */
    if (D.querySelector('[data-cart-drawer]')) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paint(c.item_count || 0); })
      .catch(function () {});
  });
})();

/* footer akordeonu ve marka yazısı sığdırma: sections/footer.liquid içinde */

/* ---------- kaydırınca belirme ([data-reveal]) ---------- */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && window.Shopify.designMode;
  function showAll(scope) { each('[data-reveal]', function (el) { el.classList.add('is-revealed'); }, scope); }
  if (reduce || editor || !('IntersectionObserver' in window)) { showAll(); R.classList.remove('js-reveal'); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-revealed');
      io.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
  function watch(scope) { each('[data-reveal]:not(.is-revealed)', function (el) { io.observe(el); }, scope); }
  watch();
  /* güvenlik: bir şey ters giderse içerik 4 sn sonra yine de görünsün */
  setTimeout(function () {
    each('[data-reveal]:not(.is-revealed)', function (el) {
      if (el.getBoundingClientRect().top < innerHeight) el.classList.add('is-revealed');
    });
  }, 4000);
  D.addEventListener('shopify:section:load', function (e) { showAll(e.target); });
  window.DedeReveal = { watch: watch };
})();
})();
